import {CollectionReference, doc} from 'firebase/firestore';
import {ObservableStatus} from 'reactfire';
import {FirestoreWritable} from './FirestoreWritable';
import {Collection, Status} from './types';
import {Entity, EntityPrototype, EntityWithMetadata, IdGenerator} from '#common/models/Entity';

export class FirestoreCollection<T extends Entity> extends FirestoreWritable<T> implements Collection<T> {
  constructor(
    private readonly idGenerator: IdGenerator<T>,
    currentUserId: string,
    private readonly reference: CollectionReference<EntityWithMetadata<T>>,
    private readonly observable: ObservableStatus<EntityWithMetadata<T>[]>,
  ) {
    super(reference.firestore, currentUserId);
    this.add = this.add.bind(this);
    this.isLoading = this.isLoading.bind(this);
    this.observe = this.observe.bind(this);
    this.status = this.status.bind(this);
  }

  async add(entity: EntityPrototype<T>): Promise<void> {
    const id = this.idGenerator(entity);
    const entityDoc = doc(this.reference, id);
    return this.createDocument(entityDoc, {...entity, id} as T);
  }

  isLoading(): boolean {
    return this.status() === 'loading';
  }

  observe(): ObservableStatus<EntityWithMetadata<T>[]> {
    return this.observable;
  }

  status(): Status {
    return this.observable.status;
  }
}
